<template>
  <v-select
    :items="items"
    :value="value"
    @input="$emit('input', $event)"
    multiple
    item-text="name"
    item-value="id"
    dense
    outlined
    hide-details
  >
  </v-select>
</template>

<script>
import gql from 'graphql-tag'
export default {
  props: {
    value: [Number, Array],
  },
  data () {
    return {
      items: []
    }
  },
  watch: {
    items () {
      this.$emit('input', this.items.map(item => item.id))
    }
  },
  apollo: {
    items: {
      query: gql`
        query{
          enumClientActionMethodList{
            id
            name
            isFaceToFace
          }
        }`,
      update: data => data.enumClientActionMethodList.filter(item => item.isFaceToFace)
    }
  }
}
</script>
